/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-media" */ `./list.vue` );
const Upload = () => import( /* webpackChunkName: "group-media" */ `./upload.vue` );
const Add = () => import( /* webpackChunkName: "group-media" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-media" */ `./edit.vue` );

export default {
	path: `media`,
	children: [
		{
			path: ``,
			name: `list-media`,
			component: List,
			meta: {
				title: `Media`
			}
		},
		{
			path: `upload`,
			name: `upload-media`,
			component: Upload,
			meta: {
				title: `Upload Media`
			}
		},
		{
			path: `new`,
			name: `add-media`,
			component: Add,
			meta: {
				title: `Add Media`
			}
		},
		{
			path: `:uuid`,
			name: `edit-media`,
			component: Edit,
			meta: {
				title: `Edit Media`
			}
		}
	]
};
